import {createContext} from 'react';

const inicioContext = createContext();

export default inicioContext;